import PropTypes from "prop-types"

import { getBadgeClass } from "helpers/product/badge"
import { cn } from "styles/utils"

const Badge = ({ className, label, variant }) => {
  const variantClass = getBadgeClass(variant)

  return (
    <span
      className={cn(
        "z-1 bg-grey-4 text-12 desktop:left-20 desktop:top-20 h-18 absolute left-0 top-8 inline-flex items-center justify-center rounded-full px-6 font-medium text-black",
        variantClass,
        className
      )}
    >
      {label}
    </span>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
}

export default Badge
